import React, { Component } from 'react'
import { ReactComponent as CheckboxIcon } from "../images/checkbox.svg";

export default class Checkbox extends Component {
  render() {
    const { children, theme, ...props } = this.props;
    return (
      <div className={`checkbox ${theme ? "checkbox--" + theme : ""}`}>
        <input type="checkbox" {...props} />
        <span className="checkbox__view">
          <CheckboxIcon />
        </span>
        <span>{children}</span>
      </div>
    )
  }
}
